/* File: components/TreeAccordion.vue */
<template>
  <nav class="tree-accordion" aria-label="Tree Accordion">
    <TreeNode
      v-for="(item, idx) in items"
      :key="item.id || idx"
      :node="item"
      :level="0"
      :is-open="isOpen"
      :toggle="toggle"
    />
  </nav>
</template>

<script setup>
import { reactive } from 'vue'
import TreeNode from './TreeNode.vue'

const props = defineProps({
  items: { type: Array, required: true }
})

// локальное состояние открытых узлов (ключи — id узла)
const openState = reactive({})
function isOpen(id){ return !!openState[id] }
function toggle(id){ openState[id] = !openState[id] }
</script>

<style scoped>
.tree-accordion{ 
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-wrap: nowrap;
  padding-top: 1rem;
  border-top: 0.2rem solid var(--grey-1);
}
</style>

